export default __webpack_public_path__ + "static/media/pirate-ship-4.6665738f.png";